<template>
  <div>
    <ProToPlusReactivationBanner v-if="!dismissed" @openModal="openModal" @dismiss="dismiss" />
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

import ProToPlusReactivationBanner from '@/components/homePage/studioPlus/ProToPlusReactivationBanner.vue'

import appAnalytics from '@/utils/tracking'
import { useProToPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useProToPlusReactivation'

const props = defineProps({
  itemId: {
    type: Number,
    required: true,
  },
  source: {
    type: String,
    default: 'homepage_banner',
  },
  dismissKey: {
    type: String,
    default: 'pro_to_plus_banner_dismissed',
  },
})

const { openProToPlusModal } = useProToPlusReactivation()

const storageKey = computed(() => `${props.dismissKey}_${props.itemId}`)
const dismissed = ref(window.localStorage.getItem(storageKey.value) === 'true')

watch(storageKey, (key) => {
  dismissed.value = window.localStorage.getItem(key) === 'true'
})

const openModal = () => {
  appAnalytics.track(appAnalytics.events.PRO_TO_PLUS_MODAL_OPENED, {
    item_id: props.itemId,
    source: props.source,
  })
  openProToPlusModal(props.itemId, props.source)
}

const dismiss = () => {
  dismissed.value = true
  window.localStorage.setItem(storageKey.value, 'true')
}
</script>
